import { useState, useRef } from "react";
import * as Popover from "@radix-ui/react-popover";
import { Input } from "./ui/input";
import AddIcon from "./icons/AddIcon";
import MagnifyingGlass from "../assets/icons/MagnifyingGlass";

const ReportDropdown = ({ resortId, templates, addReportMutation }) => {
  const [searchPhrase, setSearchPhrase] = useState<string>("");
  const [open, setOpen] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);

  const onSearchChange = ({ target }: React.ChangeEvent<HTMLInputElement>) =>
    setSearchPhrase(target.value.toLocaleLowerCase());

  const filtered = templates.filter(({ name }) =>
    name.toLocaleLowerCase().includes(searchPhrase)
  );

  return (
    <Popover.Root open={open} onOpenChange={setOpen}>
      <Popover.Trigger asChild>
        <button
          className="self-center flex items-center gap-1.5 px-2.5 py-1 rounded-[20px] text-[11px] font-medium whitespace-nowrap bg-[#F4A832] text-[#0F0F0F] hover:bg-[#e09620] border-none transition-colors cursor-pointer"
          aria-label="Dodaj raport"
        >
          <AddIcon />
          Dodaj raport
        </button>
      </Popover.Trigger>

      <Popover.Portal>
        <Popover.Content
          className="z-50 w-64 rounded-[var(--sc-radius-lg)] border border-[var(--sc-border)] bg-[var(--sc-surface)] shadow-lg outline-none"
          sideOffset={6}
          align="start"
          onOpenAutoFocus={(e) => {
            e.preventDefault();
            inputRef.current?.focus();
          }}
        >
          {/* Search */}
          <div className="p-2 border-b border-[var(--sc-border)]">
            <div className="relative">
              <span className="absolute left-2.5 top-1/2 -translate-y-1/2 text-[var(--sc-muted)]">
                <MagnifyingGlass />
              </span>
              <Input
                ref={inputRef}
                type="search"
                placeholder="Wyszukaj"
                className="pl-8"
                onKeyDown={(e) => e.stopPropagation()}
                onChange={onSearchChange}
                value={searchPhrase}
              />
            </div>
          </div>

          {/* Items */}
          <div className="max-h-60 overflow-y-auto py-1">
            {filtered.length === 0 && (
              <p className="px-3 py-2 text-xs text-[var(--sc-muted)]">Brak wyników</p>
            )}
            {filtered.map((template) => (
              <button
                key={template.id}
                className="w-full text-left px-3 py-2 text-sm text-[var(--sc-text)] hover:bg-[var(--sc-bg)] transition-colors border-none bg-transparent cursor-pointer"
                onClick={() => {
                  addReportMutation({ resortId, templateId: template.id });
                  setOpen(false);
                  setSearchPhrase("");
                }}
              >
                {template.name}
              </button>
            ))}
          </div>
        </Popover.Content>
      </Popover.Portal>
    </Popover.Root>
  );
};

export default ReportDropdown;

